import { FlaskConical } from "lucide-react";
import { useFeatures } from "@/lib/features";

export const DemoBadge = () => {
  const { isDemo } = useFeatures();
  if (!isDemo) return null;
  return (
    <div
      data-testid="demo-badge"
      className="fixed top-2 left-1/2 -translate-x-1/2 z-[9997] flex items-center gap-1.5 rounded-full bg-amber-400 text-amber-950 shadow-lg px-3 py-1 text-[11px] font-bold uppercase tracking-wider pointer-events-none select-none"
    >
      <FlaskConical className="w-3.5 h-3.5" /> Demo — dati fittizi
    </div>
  );
};

export default DemoBadge;
